import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../common-styles.css';
import './GlobalPresencePage.css';
import GradientHero from '../shared/GradientHero';
import { Link } from 'react-router-dom';

const GlobalPresencePage: React.FC = () => {
  return (
    <div className="global-presence-page">
      <GradientHero
        title={<><span>Global Platforms,</span><br/>Timeless Creations</>}
        backTo="/"
        badgeText="EVENTS & EXHIBITIONS"
        subtitleHighlight="SunDiam"
        subtitleRest=" On Stage"
        lead={<>At SunDiam, we participate in renowned global exhibitions to showcase the exceptional craftsmanship, precision, and artistry behind every diamond we create. These events allow us to connect with industry professionals, share our passion for fine diamond manufacturing, and demonstrate the high standards and skill of our artisans to the world.</>}
        className="gp-hero"
      />

      <section className="gp-event-section">
        <Container>
          <Row>
            <Col>
              <h2 className="section-title gp-event-title"><span className="section-title-highlight">At IIJS</span> Premium 2025</h2>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <div className="gp-event-collage first-collage-layout">
                <div className="gp-collage-left"><img src={require('../../assets/images/global-presense/1-1.png')} alt="Event booth" /></div>
                <div className="gp-collage-right-top"><img src={require('../../assets/images/global-presense/1-2.png')} alt="Event signage" /></div>
                <div className="gp-collage-right-bottom">
                  <div className="bottom-img"><img src={require('../../assets/images/global-presense/1-3.png')} alt="Team group" /></div>
                  <div className="bottom-img"><img src={require('../../assets/images/global-presense/1-4.png')} alt="Brand display" /></div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="mx-auto">
              <h5 className="gp-event-subtitle">Celebrating Artistry, Innovation & Excellence in Diamond Craftsmanship</h5>
              <p className="gp-event-text">SunDiam was proud to be a part of the IIJS Premium Show, held from 30th June to 3rd July 2025 at the prestigious JIO World Convention Centre, Mumbai. At Booth No. JIO-L 19K, we showcased our finest selection of natural diamonds — a reflection of precision, passion, and the skilled craftsmanship of our artisans.</p>
              <p className="gp-event-text">The event offered us a platform to connect with industry leaders, partners, and enthusiasts while highlighting our commitment to ethical sourcing, world-class quality, and timeless design. Each diamond on display embodied the spirit of innovation and excellence that drives everything we do at SunDiam.</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* JCK Las Vegas Section */}
      <section className="gp-event-section gp-event-section-jck">
        <Container>
          <Row>
            <Col>
              <h2 className="section-title gp-event-title"><span className="section-title-highlight">At JCK</span> 2025, Las Vegas</h2>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <div className="jck-collage-layout">
                <div className="gp-collage-left-side">
                  <div className="gp-collage-left-top"><img src={require('../../assets/images/global-presense/2-1.png')} alt="Attendees" /></div>
                  <div className="gp-collage-left-bottom">
                    <div className="bottom-img"><img src={require('../../assets/images/global-presense/2-2.png')} alt="Evening event" /></div>
                    <div className="bottom-img"><img src={require('../../assets/images/global-presense/2-3.png')} alt="Expo crowd" /></div>
                  </div>
                </div>
                <div className="gp-collage-right-big"><img src={require('../../assets/images/global-presense/2-4.png')} alt="Booth showcase" /></div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="mx-auto">
              <h5 className="gp-event-subtitle">Presenting Timeless Craftsmanship on the Global Stage</h5>
              <p className="gp-event-text">SunDiam proudly showcased its artistry at the JCK Show, held from 6th to 9th June 2025 at The Venetian Expo, Las Vegas. Positioned at Booth No. 5070, we welcomed global buyers and industry leaders to experience our finest natural diamonds.</p>
              <p className="gp-event-text">This premier event was an ideal platform to highlight our dedication to precision cutting, ethical sourcing, and Indian craftsmanship. Our participation reflected our vision to blend heritage with innovation and bring brilliance to the world, one diamond at a time.</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="gp-placeholder-section">
        <Container>
          <Row>
            <Col className="text-center">
              <Link to="/" className="back-link-inline">&larr; Back to Home</Link>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default GlobalPresencePage;
